import { preselectedModelFor, type ProviderStatus } from "@rivets/core";

/**
 * The model id a new task's picker starts on: the saved default while the
 * worker still offers it, else the model the provider runs by default. Empty
 * when neither exists — the task then names no model and the provider's CLI
 * picks, which is what the picker shows as the agent's default. Never the
 * first model listed: that would quietly pin a model nobody chose.
 */
export function taskModelSeed(status: ProviderStatus | undefined, preferredModel?: string): string {
  return preselectedModelFor(status, preferredModel)?.id ?? "";
}
